import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    typeListData: {
      type: Array,
      default() {
        return [];
      }
    },
    tempTableData: {
      type: Array,
      default() {
        return [];
      }
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      filterName: '',
      currentType: undefined,
      typeList: [],
      tableData: []
    };
  },
  computed: {
    visibleModal: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  created() {
    this.typeList = this.typeListData;
    this.tableData = this.tempTableData;
  },
  methods: {
    closeAdd() {
      this.visibleModal = false;
      this.filterName = '';
      this.currentType = undefined;
      this.typeList.map((item, index) => {
        if (this.tableData.length) {
          if (item.item && item.item.length) {
            item.item.map((item1, index1) => {
              let res = this.tableData.map(table => table.id);
              if (res.includes(item1.id)) {
                this.typeList[index].item[index1].selected = true;
              } else {
                this.typeList[index].item[index1].selected = false;
              }
            });
          }
        } else {
          if (item.item && item.item.length) {
            item.item.map((item1, index1) => {
              this.typeList[index].item[index1].selected = false;
            });
          }
        }
      });
    },
    checkedCurrentType(i) {
      this.currentType = i;
      this.filterName = '';
    },
    onSave() {
      this.tableData = this.filterAddData(this.typeList, this.tableData);
      this.$emit('onSave', this.tableData);
      this.closeAdd();
    },
    filterAddData(data, table = []) {
      let newData = [];
      data.map(item => {
        if (item.item && item.item.length) {
          item.item.map(info => {
            if (info.selected) {
              let finded = table.find(i => i.id == info.id);
              let obj = {
                id: info.id,
                insureTemplateId: info.id,
                name: info.name,
                type: item.name,
                control: info.display,
                isRequired: finded ? finded.isRequired : info.isRequired,
                isTag: finded ? finded.isTag : info.isTag,
                isSend: finded ? finded.isSend : info.isSend
              };
              newData.push(obj);
            }
          });
        }
      });
      return newData;
    }
  }
};